import styled from 'styled-components';

export const BookingTimeText = styled.p`
  display: flex;
  font: 400 14px ${({ theme }) => theme.fonts.join()};
  line-height: 22px;
  color: ${({ theme }) => theme.colors.palette.systemGreyDark};
  margin: 0;
`;
